export function MarqueeBanner() {
  const items = [
    "Silk Press",
    "Braids",
    "Locs",
    "Custom Color",
    "Bridal",
    "Wigs",
    "Natural Hair",
    "Treatments",
  ];

  return (
    <div className="marquee-banner">
      <div className="marquee-banner__track">
        {[...items, ...items].map((item, index) => (
          <span key={`${item}-${index}`} className="marquee-banner__item">
            {item} ✦
          </span>
        ))}
      </div>
    </div>
  );
}
